import { TimelineMarker } from './TimelineData';

export function getTimelineMarkerIdsForLogEntry(
  markers: Iterable<TimelineMarker>,
  logEntryIndex: number,
): Set<number> {
  const markerIds = new Set<number>();

  for (const marker of markers) {
    if (marker.logEntry.index === logEntryIndex) {
      markerIds.add(marker.markerId);
    }
  }

  return markerIds;
}
